import React from 'react'
import { Controller } from 'react-hook-form'
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

const PhoneController = ({
    name,
    control,
    defaultValue,
    handleInputChange,
    error,
    ...rest
}) => {
    console.log(error, 'wodkwokwdokowdk');
    
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, formState, fieldState }) => (
                <>
                    <PhoneInput
                        name={name}
                        style={{
                            backgroundColor: "transparent",
                            border: "1px solid white",
                            borderRadius: "5px",
                            width: "100%",
                            height: "40px",
                            fontSize: "16px",
                            fontWeight: "500",
                            color: 'white',
                            '--react-international-phone-country-selector-background-color' : 'transparent',
                        }}
                        inputStyle={{
                            backgroundColor: "transparent",
                            border: "none",
                            height: "40px",
                            borderRadius: "5px",
                            padding: "10px",
                            width: "100%",
                            color: 'white'
                        }}
                        countrySelectorStyleProps={{
                            buttonStyle: {
                                backgroundColor: "transparent",
                                border: "none",
                                height : '100%',
                                width: "50px",
                            }
                        }}
                        
                        {...rest}
                        value={field.value}
                        defaultCountry='us'
                        onChange={(phone, meta) => {
                            field.onChange(phone)
                            if (handleInputChange) handleInputChange(phone, meta)
                        }}
                    />
                    {
                        error && (
                            <p className="text-red-500 text-[12px] mt-[10px]">
                                {error}
                            </p>
                        )
                    }
                </>
            )}
        />
    )
}

export default PhoneController